export class OmapiCharacteristics {
  weightfr: number;
  weightnl: number;
}
